// Canadian Provinces and Territories
// Two-character codes as used by Canada Post and government systems

export const CANADIAN_PROVINCES = [
  { code: 'AB', name: 'Alberta' },
  { code: 'BC', name: 'British Columbia' },
  { code: 'MB', name: 'Manitoba' },
  { code: 'NB', name: 'New Brunswick' },
  { code: 'NL', name: 'Newfoundland and Labrador' },
  { code: 'NS', name: 'Nova Scotia' },
  { code: 'ON', name: 'Ontario' },
  { code: 'PE', name: 'Prince Edward Island' },
  { code: 'QC', name: 'Quebec' },
  { code: 'SK', name: 'Saskatchewan' },
  { code: 'NT', name: 'Northwest Territories' },
  { code: 'NU', name: 'Nunavut' },
  { code: 'YT', name: 'Yukon' }
];

// Helper function to get province name by code
export const getProvinceName = (code) => {
  const province = CANADIAN_PROVINCES.find(p => p.code === code);
  return province ? province.name : code;
};

// Helper function to get province code by name
export const getProvinceCode = (name) => {
  const province = CANADIAN_PROVINCES.find(p => p.name === name);
  return province ? province.code : name;
};

// Helper function to validate province code
export const isValidProvinceCode = (code) => {
  return CANADIAN_PROVINCES.some(p => p.code === code);
};

export default CANADIAN_PROVINCES;
